import ConfigurationService, { ConfigurationKeys } from 'services/ConfigurationService';
import messagingService from 'services/MessagingService/MessagingService';
import {
  AUTOBILLING_OPTIN,
  AUTOBILLING_OPTIN_ERROR,
  AUTOBILLING_OPTIN_RESPONSE,
  GET_AUTOBILLING_STATUS,
  GET_AUTOBILLING_STATUS_ERROR,
  GET_AUTOBILLING_STATUS_RESPONSE,
  TRIGGER_AUTOBILLING,
  TRIGGER_AUTOBILLING_ERROR,
  TRIGGER_AUTOBILLING_RESPONSE,
} from 'services/MessagingService/EventNames';
import ApiService from 'services/ApiService/ApiService';


const BASE_URL = ConfigurationService.get(ConfigurationKeys.BASE_URL);

class PaymentService {
  constructor() {
    this.messagingService = messagingService();
    this.messagingService.on(GET_AUTOBILLING_STATUS, this.getAutoBillingStatus);
    this.messagingService.on(AUTOBILLING_OPTIN, this.handleAutoBillingOptIn);
    this.messagingService.on(TRIGGER_AUTOBILLING, this.handleAutoBillingTrigger);
  }

  destructor() {
    this.messagingService.off(TRIGGER_AUTOBILLING, this.handleAutoBillingTrigger);
    this.messagingService.off(GET_AUTOBILLING_STATUS, this.getAutoBillingStatus);
    this.messagingService.off(AUTOBILLING_OPTIN, this.handleAutoBillingOptIn);
  }

  api = {
    AUTOBILLING_STATUS: `${BASE_URL}/rest/v1.0/payment/{username}/options/autoBilling`,
    AUTOBILLING_TRIGGER: `${BASE_URL}/rest/v1.0/payment/{username}/autoBilling`,
  };

  getAutoBillingStatus = async(username) => {
    try {
      const url = ApiService.substitute(
        this.api.AUTOBILLING_STATUS,
        { username: encodeURIComponent(username) }
      );
      const response = await ApiService.get(url);
      this.messagingService.emit(GET_AUTOBILLING_STATUS_RESPONSE, response.data);
    } catch (e) {
      this.messagingService.emit(GET_AUTOBILLING_STATUS_ERROR, e);
    }
  };

  handleAutoBillingOptIn = async({ status, username }) => {
    try {
      const url = ApiService.substitute(
        this.api.AUTOBILLING_STATUS,
        { username: encodeURIComponent(username) }
      );
      const data = { status };
      const response = await ApiService.post(url, { data });
      this.messagingService.emit(AUTOBILLING_OPTIN_RESPONSE, response.data);
    } catch (e) {
      this.messagingService.emit(AUTOBILLING_OPTIN_ERROR, e);
    }
  };

  handleAutoBillingTrigger = async({ username }) => {
    try {
      const url = ApiService.substitute(
        this.api.AUTOBILLING_TRIGGER,
        { username: encodeURIComponent(username) }
      );
      const response = await ApiService.post(url);
      this.messagingService.emit(TRIGGER_AUTOBILLING_RESPONSE, response.data);
    } catch (error) {
      this.messagingService.emit(TRIGGER_AUTOBILLING_ERROR, error);
    }
  };
}

export default new PaymentService();
